// "use strict";

// jQuery(document).ready(function($) {

// 	var adpPopup = {};

// 	( function() {
// 		var $this;

// 		adpPopup = {
// 			sPrevious : window.scrollY,
// 			sDirection: 'down',

// 			/*
// 			* Initialize
// 			*/
// 			init: function( e ) {
// 				$this = adpPopup;

// 				$this.popupInit( e );

// 				// Init events.
// 				$this.events( e );
// 			},

// 			/*
// 			* Events
// 			*/
// 			events: function( e ) {
// 				// Custom Events
// 				$( document ).on( 'click', '.popup-close', $this.closePopup );
// 				$( document ).on( 'click', '.popup-accept', $this.acceptPopup );
// 				$( document ).on( 'click', '.popup-accept', $this.closePopup );
// 				$( document ).on( 'click', '.age-verification__popup-close', $this.agePopup );
// 				$( document ).on( 'click', '.age-verification__popup-close', $this.closePopup );
// 				$( document ).on( 'click', '.age-verification__button-no', $this.ageDeclined );

// 				// Book a Demo: if the demo form inside this popup is submitted,
// 				// remember it for the rest of the session so the auto-open
// 				// trigger does not fire again on another page.
// 				$( document ).on( 'submit', '.popup-book-free-demo form', function() {
// 					$this.setSessionFlag( 'popup-book-demo-dismissed' );
// 				} );

// 				// Checking this will cause popup to close when user presses key.
// 				$( document ).keyup(function(e) {
// 					// Press ESC to Close.
// 					if ( e.key === 'Escape' ) {
// 						$( '.popup-open[data-esc-close="true"]' ).each(function(index, popup) {
// 							$this.closePopup(popup);
// 						});
// 					}

// 					// Press F4 to Close.
// 					if ( e.key === 'F4' ) {
// 						$( '.popup-open[data-f4-close="true"]' ).each(function(index, popup) {
// 							$this.closePopup(popup);
// 						});
// 					}
// 				});

// 				// Checking this will cause popup to close when user clicks on overlay.
// 				$( document ).on( 'click', '.popup-overlay', function( e ) {
// 					$( '.popup-open[data-overlay-close="true"]' ).each(function(index, popup) {
// 						$this.closePopup(popup);
// 						//$this.closePopup( $( this).prev() );
// 					})
// 				} );
// 			},

// 			/*
// 			* Init popup elements
// 			*/
// 			popupInit: function( e ) {

// 				// Set scroll direction.
// 				$( document ).on( 'scroll', function() {

// 					let scrollCurrent = window.scrollY;

// 					// Set scroll temporary vars.
// 					if ( scrollCurrent > $this.sPrevious ) {
// 						$this.sDirection = 'down';
// 					} else {
// 						$this.sDirection = 'up';
// 					}

// 					$this.sPrevious = scrollCurrent;
// 				});

// 				// Open popup
// 				$( '.popup' ).each(function(index, popup) {

// 					// Manual Launch.
// 					if ( 'manual' === $( popup ).data( 'open-trigger' ) ) {

// 						let selector = $( popup ).data( 'open-manual-selector' );

// 						if ( selector ) {
// 							$(selector).addClass('popup-trigger')

// 							$( document ).on( 'click', selector, function( e ) {
// 								e.preventDefault();

// 								$( popup ).removeClass( 'popup-already-opened' );

// 								$this.openPopup( popup );

// 								if (e.currentTarget.classList.contains('popup')) {
// 									$this.closePopup(selector);
// 								}
// 							} );
// 						}


// 					}

// 					// Checks whether a popup should be displayed or not.
// 					if ( ! $this.isAllowPopup( popup ) && ! $(popup).hasClass('age-verification')) {
// 						return;
// 					}

// 					$this.openTriggerPopup( popup );
// 				});

// 				// Auto-open the "Book a Demo" popup once per browser session on
// 				// the collections/products/tags selected in the theme editor.
// 				// This is independent of the popup's normal open trigger above,
// 				// and only applies to the popup that has a "Book a Free Demo" block.
// 				//
// 				// QA tip: add ?preview-book-demo=1 to any URL to force this
// 				// popup open immediately — ignoring the matching rules, the
// 				// once-per-session flag, and the delay. Useful for testing a
// 				// specific page without clearing sessionStorage every time.
// 				let forceBookDemoPreview = /(?:^|[?&])preview-book-demo=1(?:&|$)/.test( window.location.search );

// 				$( '.popup-main--book-demo' ).each(function(index, popup) {
// 					let $popup = $( popup );

// 					if ( forceBookDemoPreview ) {
// 						$this.openPopup( popup );
// 						return;
// 					}

// 					// Only proceed if this specific popup's matching rules
// 					// (product/collection/tag) resolved to true for this page.
// 					if ( $popup.attr( 'data-auto-open-book-demo' ) !== 'true' ) {
// 						return;
// 					}

// 					// Already closed/submitted/shown earlier this session —
// 					// never auto-open again until the browser tab/session ends.
// 					if ( $this.getSessionFlag( 'popup-book-demo-dismissed' ) ) {
// 						return;
// 					}

// 					let delay = parseInt( $popup.data( 'auto-open-book-demo-delay' ) || 0, 10 );

// 					setTimeout( function() {
// 						// Re-check right before opening — the visitor may have
// 						// already dismissed it (e.g. via a different popup
// 						// instance) while this timer was pending.
// 						if ( $this.getSessionFlag( 'popup-book-demo-dismissed' ) ) {
// 							return;
// 						}

// 						// Mark as used right away so it only ever auto-opens
// 						// once per session, even if the visitor navigates away
// 						// without explicitly closing or submitting it.
// 						$this.setSessionFlag( 'popup-book-demo-dismissed' );

// 						$this.openPopup( popup );
// 					}, delay * 1000 );
// 				});
// 			},

// 			/*
// 			* Trigger open popup
// 			*/
// 			openTriggerPopup: function( e ) {
// 				let popup = ( e.originalEvent ) ? this : e;


// 				var trigger = $( popup ).data( 'open-trigger' );

// 				// Age Verification.
// 				if ( 'none' === trigger ) {
// 					let ageVerification = $this.getStorage(
// 						'popup-age-' + $(popup).data('id') || 0
// 					)


// 					if (!ageVerification) 
// 						$this.openPopup( popup );
// 				}

// 				// Time Delay.
// 				if ( 'delay' === trigger ) {
// 					setTimeout( function() {

// 						$this.openPopup( popup );

// 					}, $( popup ).data( 'open-delay-number' ) * 1000 );
// 				}

// 				// Exit Intent.
// 				if ( 'exit' === trigger ) {
// 					var showExit = true;
// 					document.addEventListener( "mousemove", function( e ) {
// 						// Get current scroll position
// 						var scroll = window.pageYOffset || document.documentElement.scrollTop;
// 						if ( ( e.pageY - scroll ) < 7 && showExit ) {
// 							$this.openPopup( popup );
// 							showExit = false;
// 						}
// 					} );
// 				}

// 				// Scroll Position.
// 				if ( 'scroll' === trigger ) {

// 					var pointScrollType     = $( popup ).data( 'open-scroll-type' );
// 					var pointScrollPosition = $( popup ).data( 'open-scroll-position' );

// 					// Event scroll.
// 					$( document ).on( 'scroll', function() {

// 						// Type px.
// 						if ( 'px' === pointScrollType ) {

// 							if ( window.scrollY >= pointScrollPosition ) {
// 								$this.openPopup( popup );
// 							}
// 						}

// 						// Type %.
// 						if ( '%' === pointScrollType ) {

// 							if ( $this.getScrollPercent() >= pointScrollPosition ) {
// 								$this.openPopup( popup );
// 							}
// 						}
// 					} );
// 				}

// 				// Accept Agreement.
// 				if ( 'accept' === trigger ) {
// 					let accept = $this.getStorage(
// 						'popup-accept-' + $(popup).data('id') || 0
// 					)

// 					if ( ! accept ) {
// 						$this.openPopup( popup );
// 					}
// 				}
// 			},

// 			/*
// 			* Trigger close popup
// 			*/
// 			closeTriggerPopup: function( e ) {
// 				let popup = ( e.originalEvent ) ? this : e;

// 				var trigger = $( popup ).data( 'close-trigger' );

// 				// Time Delay.
// 				if ( 'delay' === trigger ) {
// 					setTimeout( function() {

// 						$this.closePopup(popup);

// 					}, $( popup ).data( 'close-delay-number' ) * 1000 );
// 				}

// 				// Scroll Position.
// 				if ( 'scroll' === trigger ) {

// 					var pointScrollType     = $( popup ).data( 'close-scroll-type' );
// 					var pointScrollPosition = $( popup ).data( 'close-scroll-position' );
// 					var initScrollPx        = $( popup ).data( 'init-scroll-px' );
// 					var initScrollPercent   = $( popup ).data( 'init-scroll-percent' );

// 					// Event scroll.
// 					$( document ).on( 'scroll', function() {

// 						// Type px.
// 						if ( 'px' === pointScrollType ) {

// 							if ( 'up' === $this.sDirection && window.scrollY < ( initScrollPx - pointScrollPosition ) ) {
// 								$this.closePopup( popup );
// 							}

// 							if ( 'down' === $this.sDirection && window.scrollY >= ( initScrollPx + pointScrollPosition ) ) {
// 								$this.closePopup( popup );
// 							}
// 						}

// 						// Type %.
// 						if ( '%' === pointScrollType ) {

// 							if ( 'up' === $this.sDirection && $this.getScrollPercent() < ( initScrollPercent - pointScrollPosition ) ) {
// 								$this.closePopup(popup);
// 							}

// 							if ( 'down' === $this.sDirection && $this.getScrollPercent() >= ( initScrollPercent + pointScrollPosition ) ) {
// 								$this.closePopup(popup);
// 							}
// 						}
// 					} );
// 				}
// 			},

// 			/*
// 			* Open popup
// 			*/
// 			openPopup: function( e ) {
// 				let popup = ( e.originalEvent ) ? this : e;

// 				if ( $( popup ).hasClass( 'popup-open' ) ) {
// 					return;
// 				}

// 				// Check already opened.
// 				if ( $( popup ).hasClass( 'popup-already-opened' ) ) {
// 					return;
// 				}

// 				// Hide body scroll.
// 				if ( $( popup ).is( '[data-body-scroll-disable="true"]' ) ) {
// 					$( 'body' ).addClass( 'popup-scroll-hidden' );
// 				}

// 				// Set Cookie of Limit display.
// 				let limit =
// 					parseInt($this.getStorage('popup-' + $(popup).data('id')) || 0) + 1

// 				$this.setStorage('popup-' + $(popup).data('id'), limit, {
// 					expires: $(popup).data('limit-lifetime'),
// 				})

// 				// Display popup.
// 				$( popup ).addClass( 'popup-open' );

// 				// Set current scroll.
// 				$( popup ).data( 'init-scroll-px', window.scrollY );
// 				$( popup ).data( 'init-scroll-percent', $this.getScrollPercent() );

// 				// Open animation.
// 				let animation = $( popup ).data( 'open-animation' );

// 				$this.applyAnimation( popup, animation );

// 				// Init close trigger.
// 				$this.closeTriggerPopup( popup );
// 			},

// 			/*
// 			* Age popup
// 			*/
// 			agePopup: function( e ) {
// 				let $el = ( e.originalEvent ) ? this : e;

// 				// Get popup container.
// 				let popup = $( $el ).closest( '.popup' );

// 				// Set Cookie of Age.
// 				$this.setStorage('popup-age-' + $(popup).data('id'), 1, {
// 					expires: 360,
// 				})
// 			},

// 			/*
// 			* Age declined
// 			*/

// 			ageDeclined: function() {
// 				$( '.age-verification__question' ).removeClass('show');
// 				$( '.age-verification__declined' ).addClass('show');
// 			},


// 			/*
// 			* Accept popup
// 			*/
// 			acceptPopup: function( e ) {

// 				let $el = ( e.originalEvent ) ? this : e;

// 				// Get popup container.
// 				let popup = $( $el ).closest( '.popup' );

// 				// Set Cookie of Accept.
// 				$this.setStorage('popup-accept-' + $(popup).data('id'), 1, {
// 					expires: 360,
// 				})
// 			},

// 			/*
// 			* Close popup
// 			*/
// 			closePopup: function( e ) {

// 				let $el = ( e.originalEvent ) ? this : e;

// 				// Get popup container.
// 				let popup = $( $el ).closest( '.popup' );

// 				// Book a Demo: remember for the rest of the session that this
// 				// popup was closed, so the auto-open trigger stays off.
// 				if ( $( popup ).hasClass( 'popup-main--book-demo' ) ) {
// 					$this.setSessionFlag( 'popup-book-demo-dismissed' );
// 				}

// 				// Close animation.
// 				let animation = $( popup ).data( 'exit-animation' );

// 				$this.applyAnimation( popup, animation, function() {
// 					// Already opened.
// 					$( popup ).addClass( 'popup-already-opened' );

// 					// Hide popup.
// 					$( popup ).removeClass( 'popup-open' );

// 					// Remove classes from body.
// 					//$( 'body' ).removeClass( 'popup-scroll-hidden' );
// 				} );

// 				$( 'body' ).removeClass( 'popup-scroll-hidden' );
// 			},

// 			/*
// 			* Checks whether a popup should be displayed or not
// 			*/
// 			isAllowPopup: function( e ) {
// 				let popup = ( e.originalEvent ) ? this : e;

// 				// Has user seen this popup before?
// 				let limitDisplay = parseInt( $( popup ).data( 'limit-display' ) || 0 );

// 				let limitDisplayCookie = parseInt(
// 					$this.getStorage('popup-' + $(popup).data('id'))
// 				)

// 				if ( limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay ) {
// 					return;
// 				}

// 				return true;
// 			},

// 			/*
// 			* Apply animation
// 			*/
// 			applyAnimation: function( el, name, callback ) {
// 				var popup = $( el ).closest( '.popup' );

// 				if ( typeof callback === 'function' ) {
// 					var overlayName = 'popupExitFade';
// 				} else {
// 					var overlayName = 'popupOpenFade';
// 				}

// 				// Overlay Animation.
// 				$( popup ).next( '.popup-overlay' ).addClass( 'popup-animated ' + overlayName )
// 					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
// 						$( this ).removeClass( 'popup-animated ' + overlayName );
// 					} );

// 				// Wrap Animation.
// 				$( popup ).find( '.popup-wrap' ).addClass( 'popup-animated ' + name )
// 					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
// 						// remove the animation classes after animation ends
// 						// required in order to apply new animation on close
// 						$( this ).removeClass( 'popup-animated ' + name );

// 						if ( typeof callback === 'function' ) {
// 							callback();
// 						}
// 					} );
// 			},

// 			/*
// 			* Set cookie
// 			*/
// 			getCookie: function( name ) {
// 				var matches = document.cookie.match( new RegExp(
// 					"(?:^|; )" + name.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1' ) + "=([^;]*)"
// 				) );
// 				return matches ? decodeURIComponent( matches[ 1 ] ) : undefined;
// 			},

// 			/*
// 			* Set cookie
// 			*/
// 			setCookie: function( name, value, options ) {
// 				options = options || {};

// 				options.path = options.hasOwnProperty( 'path' ) ? options.path : '/';

// 				options.expires = parseInt( options.expires );

// 				if ( typeof options.expires == "number" && options.expires ) {

// 					options.expires = new Date().setDate(new Date().getDate() + options.expires );

// 					options.expires = new Date(options.expires).toUTCString();
// 				}

// 				value = encodeURIComponent( value );

// 				var updatedCookie = name + "=" + value;

// 				for ( var propName in options ) {
// 					updatedCookie += "; " + propName;
// 					var propValue = options[ propName ];
// 					if ( propValue !== true ) {
// 						updatedCookie += "=" + propValue;
// 					}
// 				}

// 				document.cookie = updatedCookie;
// 			},

// 			/*
// 			 * Get local storage
// 			 */
// 			getStorage: function (key) {
// 				const item = localStorage.getItem(key)
// 				if (!item) return undefined

// 				try {
// 					const parsed = JSON.parse(item)
// 					if (parsed.expires && Date.now() > parsed.expires) {
// 						localStorage.removeItem(key)
// 						return undefined
// 					}
// 					return parsed.value
// 				} catch {
// 					return undefined
// 				}
// 			},

// 			/*
// 			 * Set local storage
// 			 */
// 			setStorage: function (key, value, options = {}) {
// 				const data = {
// 					value,
// 					expires: null,
// 				}
// 				if (options.expires) {
// 					const expiresDate = new Date()
// 					expiresDate.setDate(
// 						expiresDate.getDate() + parseInt(options.expires, 10)
// 					)
// 					data.expires = expiresDate.getTime()
// 				}
// 				localStorage.setItem(key, JSON.stringify(data))
// 			},

// 			/*
// 			 * Get a session-only flag (cleared when the browser tab/session ends).
// 			 * Used for the "don't auto-open the Book a Demo popup again this
// 			 * session" behavior, which intentionally does NOT persist across
// 			 * sessions the way the localStorage-based settings above do.
// 			 */
// 			getSessionFlag: function (key) {
// 				try {
// 					return sessionStorage.getItem(key);
// 				} catch {
// 					return undefined;
// 				}
// 			},

// 			/*
// 			 * Set a session-only flag.
// 			 */
// 			setSessionFlag: function (key) {
// 				try {
// 					sessionStorage.setItem(key, '1');
// 				} catch {
// 					// sessionStorage unavailable (e.g. private mode edge cases) — ignore.
// 				}
// 			},

// 			/*
// 			* Get scroll percent
// 			*/
// 			getScrollPercent: function() {
// 				var h = document.documentElement,
// 					b = document.body,
// 					st = 'scrollTop',
// 					sh = 'scrollHeight';
// 				return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
// 			}
// 		};

// 	} )();

// 	// Initialize.
// 	adpPopup.init();

// 	document.addEventListener('shopify:section:load', function () {
// 		adpPopup.init();
// 	});

// 	document.addEventListener('shopify:section:unload', function () {	
// 		$( 'body' ).removeClass( 'popup-scroll-hidden' );
// 	})
// });

"use strict";

jQuery(document).ready(function($) {

	var adpPopup = {};

	( function() {
		var $this;

		adpPopup = {
			sPrevious : window.scrollY,
			sDirection: 'down',

			/*
			* Initialize
			*/
			init: function( e ) {
				$this = adpPopup;

				$this.popupInit( e );

				// Init events.
				$this.events( e );
			},

			/*
			* Events
			*/
			events: function( e ) {
				// Custom Events
				$( document ).on( 'click', '.popup-close', $this.closePopup );
				$( document ).on( 'click', '.popup-accept', $this.acceptPopup );
				$( document ).on( 'click', '.popup-accept', $this.closePopup );
				$( document ).on( 'click', '.age-verification__popup-close', $this.agePopup );
				$( document ).on( 'click', '.age-verification__popup-close', $this.closePopup );
				$( document ).on( 'click', '.age-verification__button-no', $this.ageDeclined );

				// Book a Demo: if the demo form inside this popup is submitted,
				// remember it for the rest of the session so the auto-open
				// trigger does not fire again on another page.
				$( document ).on( 'submit', '.popup-book-free-demo form', function() {
					$this.setSessionFlag( 'popup-book-demo-dismissed' );
				} );

				// Checking this will cause popup to close when user presses key.
				$( document ).keyup(function(e) {
					// Press ESC to Close.
					if ( e.key === 'Escape' ) {
						$( '.popup-open[data-esc-close="true"]' ).each(function(index, popup) {
							$this.closePopup(popup);
						});
					}

					// Press F4 to Close.
					if ( e.key === 'F4' ) {
						$( '.popup-open[data-f4-close="true"]' ).each(function(index, popup) {
							$this.closePopup(popup);
						});
					}
				});

				// Checking this will cause popup to close when user clicks on overlay.
				$( document ).on( 'click', '.popup-overlay', function( e ) {
					$( '.popup-open[data-overlay-close="true"]' ).each(function(index, popup) {
						$this.closePopup(popup);
						//$this.closePopup( $( this).prev() );
					})
				} );
			},

			/*
			* Init popup elements
			*/
			popupInit: function( e ) {

				// Set scroll direction.
				$( document ).on( 'scroll', function() {

					let scrollCurrent = window.scrollY;

					// Set scroll temporary vars.
					if ( scrollCurrent > $this.sPrevious ) {
						$this.sDirection = 'down';
					} else {
						$this.sDirection = 'up';
					}

					$this.sPrevious = scrollCurrent;
				});

				// Open popup
				$( '.popup' ).each(function(index, popup) {

					// Manual Launch.
					if ( 'manual' === $( popup ).data( 'open-trigger' ) ) {

						let selector = $( popup ).data( 'open-manual-selector' );

						if ( selector ) {
							$(selector).addClass('popup-trigger')

							$( document ).on( 'click', selector, function( e ) {
								e.preventDefault();

								$( popup ).removeClass( 'popup-already-opened' );

								$this.openPopup( popup );

								if (e.currentTarget.classList.contains('popup')) {
									$this.closePopup(selector);
								}
							} );
						}


					}

					// Checks whether a popup should be displayed or not.
					if ( ! $this.isAllowPopup( popup ) && ! $(popup).hasClass('age-verification')) {
						return;
					}

					$this.openTriggerPopup( popup );
				});

				// Auto-open the "Book a Demo" popup once per browser session on
				// the collections/products/tags selected in the theme editor.
				// This is independent of the popup's normal open trigger above,
				// and only applies to the popup that has a "Book a Free Demo" block.
				//
				// QA tip: add ?preview-book-demo=1 to any URL to force this
				// popup open immediately — ignoring the matching rules, the
				// once-per-session flag, and the delay. Useful for testing a
				// specific page without clearing sessionStorage every time.
				let forceBookDemoPreview = /(?:^|[?&])preview-book-demo=1(?:&|$)/.test( window.location.search );

				$( '.popup-main--book-demo' ).each(function(index, popup) {
					let $popup = $( popup );

					if ( forceBookDemoPreview ) {
						$this.openPopup( popup );
						return;
					}

					// Only proceed if this specific popup's matching rules
					// (product/collection/tag) resolved to true for this page.
					if ( $popup.attr( 'data-auto-open-book-demo' ) !== 'true' ) {
						return;
					}

					// Already closed/submitted/shown earlier this session —
					// never auto-open again until the browser tab/session ends.
					if ( $this.getSessionFlag( 'popup-book-demo-dismissed' ) ) {
						return;
					}

					let delay = parseInt( $popup.data( 'auto-open-book-demo-delay' ) || 0, 10 );

					setTimeout( function() {
						// Re-check right before opening — the visitor may have
						// already dismissed it (e.g. via a different popup
						// instance) while this timer was pending.
						if ( $this.getSessionFlag( 'popup-book-demo-dismissed' ) ) {
							return;
						}

						// Mark as used right away so it only ever auto-opens
						// once per session, even if the visitor navigates away
						// without explicitly closing or submitting it.
						$this.setSessionFlag( 'popup-book-demo-dismissed' );

						$this.openPopup( popup );
					}, delay * 1000 );
				});
			},

			/*
			* Trigger open popup
			*/
			openTriggerPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;


				var trigger = $( popup ).data( 'open-trigger' );

				// Age Verification.
				if ( 'none' === trigger ) {
					let ageVerification = $this.getStorage(
						'popup-age-' + $(popup).data('id') || 0
					)


					if (!ageVerification) 
						$this.openPopup( popup );
				}

				// Time Delay.
				if ( 'delay' === trigger ) {
					setTimeout( function() {

						$this.openPopup( popup );

					}, $( popup ).data( 'open-delay-number' ) * 1000 );
				}

				// Exit Intent.
				if ( 'exit' === trigger ) {
					var showExit = true;
					document.addEventListener( "mousemove", function( e ) {
						// Get current scroll position
						var scroll = window.pageYOffset || document.documentElement.scrollTop;
						if ( ( e.pageY - scroll ) < 7 && showExit ) {
							$this.openPopup( popup );
							showExit = false;
						}
					} );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = $( popup ).data( 'open-scroll-type' );
					var pointScrollPosition = $( popup ).data( 'open-scroll-position' );

					// Event scroll.
					$( document ).on( 'scroll', function() {

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( window.scrollY >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( $this.getScrollPercent() >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}
					} );
				}

				// Accept Agreement.
				if ( 'accept' === trigger ) {
					let accept = $this.getStorage(
						'popup-accept-' + $(popup).data('id') || 0
					)

					if ( ! accept ) {
						$this.openPopup( popup );
					}
				}
			},

			/*
			* Trigger close popup
			*/
			closeTriggerPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				var trigger = $( popup ).data( 'close-trigger' );

				// Time Delay.
				if ( 'delay' === trigger ) {
					setTimeout( function() {

						$this.closePopup(popup);

					}, $( popup ).data( 'close-delay-number' ) * 1000 );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = $( popup ).data( 'close-scroll-type' );
					var pointScrollPosition = $( popup ).data( 'close-scroll-position' );
					var initScrollPx        = $( popup ).data( 'init-scroll-px' );
					var initScrollPercent   = $( popup ).data( 'init-scroll-percent' );

					// Event scroll.
					$( document ).on( 'scroll', function() {

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( 'up' === $this.sDirection && window.scrollY < ( initScrollPx - pointScrollPosition ) ) {
								$this.closePopup( popup );
							}

							if ( 'down' === $this.sDirection && window.scrollY >= ( initScrollPx + pointScrollPosition ) ) {
								$this.closePopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( 'up' === $this.sDirection && $this.getScrollPercent() < ( initScrollPercent - pointScrollPosition ) ) {
								$this.closePopup(popup);
							}

							if ( 'down' === $this.sDirection && $this.getScrollPercent() >= ( initScrollPercent + pointScrollPosition ) ) {
								$this.closePopup(popup);
							}
						}
					} );
				}
			},

			/*
			* Open popup
			*/
			openPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				if ( $( popup ).hasClass( 'popup-open' ) ) {
					return;
				}

				// Check already opened.
				if ( $( popup ).hasClass( 'popup-already-opened' ) ) {
					return;
				}

				// Hide body scroll.
				if ( $( popup ).is( '[data-body-scroll-disable="true"]' ) ) {
					$( 'body' ).addClass( 'popup-scroll-hidden' );
				}

				// Set Cookie of Limit display.
				let limit =
					parseInt($this.getStorage('popup-' + $(popup).data('id')) || 0) + 1

				$this.setStorage('popup-' + $(popup).data('id'), limit, {
					expires: $(popup).data('limit-lifetime'),
				})

				// Display popup.
				$( popup ).addClass( 'popup-open' );

				// Book a Demo: pre-select the "I'm interested in" category
				// dropdown to match the page the visitor is on, if we can
				// tell what that category is.
				if ( $( popup ).hasClass( 'popup-main--book-demo' ) ) {
					$this.applyBookDemoCategory( popup );
				}

				// Set current scroll.
				$( popup ).data( 'init-scroll-px', window.scrollY );
				$( popup ).data( 'init-scroll-percent', $this.getScrollPercent() );

				// Open animation.
				let animation = $( popup ).data( 'open-animation' );

				$this.applyAnimation( popup, animation );

				// Init close trigger.
				$this.closeTriggerPopup( popup );
			},

			/*
			 * Book a Demo: pre-select the "I'm interested in" dropdown to
			 * match the page the visitor is on. Resolution order:
			 *   1. Admin mapping (data-book-demo-category-map), keyed by the
			 *      specific sub-category handle (data-book-demo-subcategory)
			 *      — needed for ambiguous top-level categories like
			 *      "new-energy" that split into multiple dropdown options.
			 *   2. That same admin mapping, keyed by the top-level category
			 *      slug (data-book-demo-category).
			 *   3. A humanized version of the top-level category slug
			 *      ("kitchen-appliances" -> "Kitchen Appliances") matched
			 *      directly against the dropdown's visible option text.
			 * If none of those match, the dropdown is left exactly as-is.
			 */
			applyBookDemoCategory: function( popup ) {
				let $popup = $( popup );

				let $select = $popup
					.find( '#book-demo-interested, [name="lms_ProductCategoryDealingsIn"]' )
					.first();

				if ( ! $select.length ) {
					return;
				}

				let categoryMap = $this.parseBookDemoCategoryMap( $popup.attr( 'data-book-demo-category-map' ) );
				let subcategory = $popup.attr( 'data-book-demo-subcategory' );
				let category = $popup.attr( 'data-book-demo-category' );

				if ( subcategory && categoryMap[ subcategory.toLowerCase() ] ) {
					$this.selectBookDemoOption( $select, categoryMap[ subcategory.toLowerCase() ] );
					return;
				}

				if ( category && categoryMap[ category.toLowerCase() ] ) {
					$this.selectBookDemoOption( $select, categoryMap[ category.toLowerCase() ] );
					return;
				}

				if ( category ) {
					let humanized = category.replace( /[-_]+/g, ' ' ).trim();
					$this.selectBookDemoOption( $select, humanized );
				}
			},

			/*
			 * Parses the admin-entered "handle:Label" lines (one per line)
			 * into a { handle: 'Label' } lookup object, with handles
			 * lowercased for case-insensitive matching.
			 */
			parseBookDemoCategoryMap: function( raw ) {
				let map = {};

				if ( ! raw ) {
					return map;
				}

				raw.split( '\n' ).forEach(function( line ) {
					let separatorIndex = line.indexOf( ':' );

					if ( separatorIndex === -1 ) {
						return;
					}

					let key = line.slice( 0, separatorIndex ).trim().toLowerCase();
					let value = line.slice( separatorIndex + 1 ).trim();

					if ( key && value ) {
						map[ key ] = value;
					}
				});

				return map;
			},

			/*
			 * Selects the <option> in $select whose visible text exactly
			 * matches label (case-insensitive, whitespace-normalized). Does
			 * nothing if no option matches.
			 */
			selectBookDemoOption: function( $select, label ) {
				let target = label.replace( /\s+/g, ' ' ).trim().toLowerCase();

				$select.find( 'option' ).each(function() {
					let optionText = $( this ).text().replace( /\s+/g, ' ' ).trim().toLowerCase();

					if ( optionText === target ) {
						$select.val( $( this ).val() ).trigger( 'change' );
						return false;
					}
				});
			},

			/*
			* Age popup
			*/
			agePopup: function( e ) {
				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Set Cookie of Age.
				$this.setStorage('popup-age-' + $(popup).data('id'), 1, {
					expires: 360,
				})
			},

			/*
			* Age declined
			*/

			ageDeclined: function() {
				$( '.age-verification__question' ).removeClass('show');
				$( '.age-verification__declined' ).addClass('show');
			},


			/*
			* Accept popup
			*/
			acceptPopup: function( e ) {

				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Set Cookie of Accept.
				$this.setStorage('popup-accept-' + $(popup).data('id'), 1, {
					expires: 360,
				})
			},

			/*
			* Close popup
			*/
			closePopup: function( e ) {

				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Book a Demo: remember for the rest of the session that this
				// popup was closed, so the auto-open trigger stays off.
				if ( $( popup ).hasClass( 'popup-main--book-demo' ) ) {
					$this.setSessionFlag( 'popup-book-demo-dismissed' );
				}

				// Close animation.
				let animation = $( popup ).data( 'exit-animation' );

				$this.applyAnimation( popup, animation, function() {
					// Already opened.
					$( popup ).addClass( 'popup-already-opened' );

					// Hide popup.
					$( popup ).removeClass( 'popup-open' );

					// Remove classes from body.
					//$( 'body' ).removeClass( 'popup-scroll-hidden' );
				} );

				$( 'body' ).removeClass( 'popup-scroll-hidden' );
			},

			/*
			* Checks whether a popup should be displayed or not
			*/
			isAllowPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				// Has user seen this popup before?
				let limitDisplay = parseInt( $( popup ).data( 'limit-display' ) || 0 );

				let limitDisplayCookie = parseInt(
					$this.getStorage('popup-' + $(popup).data('id'))
				)

				if ( limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay ) {
					return;
				}

				return true;
			},

			/*
			* Apply animation
			*/
			applyAnimation: function( el, name, callback ) {
				var popup = $( el ).closest( '.popup' );

				if ( typeof callback === 'function' ) {
					var overlayName = 'popupExitFade';
				} else {
					var overlayName = 'popupOpenFade';
				}

				// Overlay Animation.
				$( popup ).next( '.popup-overlay' ).addClass( 'popup-animated ' + overlayName )
					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
						$( this ).removeClass( 'popup-animated ' + overlayName );
					} );

				// Wrap Animation.
				$( popup ).find( '.popup-wrap' ).addClass( 'popup-animated ' + name )
					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
						// remove the animation classes after animation ends
						// required in order to apply new animation on close
						$( this ).removeClass( 'popup-animated ' + name );

						if ( typeof callback === 'function' ) {
							callback();
						}
					} );
			},

			/*
			* Set cookie
			*/
			getCookie: function( name ) {
				var matches = document.cookie.match( new RegExp(
					"(?:^|; )" + name.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1' ) + "=([^;]*)"
				) );
				return matches ? decodeURIComponent( matches[ 1 ] ) : undefined;
			},

			/*
			* Set cookie
			*/
			setCookie: function( name, value, options ) {
				options = options || {};

				options.path = options.hasOwnProperty( 'path' ) ? options.path : '/';

				options.expires = parseInt( options.expires );

				if ( typeof options.expires == "number" && options.expires ) {

					options.expires = new Date().setDate(new Date().getDate() + options.expires );

					options.expires = new Date(options.expires).toUTCString();
				}

				value = encodeURIComponent( value );

				var updatedCookie = name + "=" + value;

				for ( var propName in options ) {
					updatedCookie += "; " + propName;
					var propValue = options[ propName ];
					if ( propValue !== true ) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			},

			/*
			 * Get local storage
			 */
			getStorage: function (key) {
				const item = localStorage.getItem(key)
				if (!item) return undefined

				try {
					const parsed = JSON.parse(item)
					if (parsed.expires && Date.now() > parsed.expires) {
						localStorage.removeItem(key)
						return undefined
					}
					return parsed.value
				} catch {
					return undefined
				}
			},

			/*
			 * Set local storage
			 */
			setStorage: function (key, value, options = {}) {
				const data = {
					value,
					expires: null,
				}
				if (options.expires) {
					const expiresDate = new Date()
					expiresDate.setDate(
						expiresDate.getDate() + parseInt(options.expires, 10)
					)
					data.expires = expiresDate.getTime()
				}
				localStorage.setItem(key, JSON.stringify(data))
			},

			/*
			 * Get a session-only flag (cleared when the browser tab/session ends).
			 * Used for the "don't auto-open the Book a Demo popup again this
			 * session" behavior, which intentionally does NOT persist across
			 * sessions the way the localStorage-based settings above do.
			 */
			getSessionFlag: function (key) {
				try {
					return sessionStorage.getItem(key);
				} catch {
					return undefined;
				}
			},

			/*
			 * Set a session-only flag.
			 */
			setSessionFlag: function (key) {
				try {
					sessionStorage.setItem(key, '1');
				} catch {
					// sessionStorage unavailable (e.g. private mode edge cases) — ignore.
				}
			},

			/*
			* Get scroll percent
			*/
			getScrollPercent: function() {
				var h = document.documentElement,
					b = document.body,
					st = 'scrollTop',
					sh = 'scrollHeight';
				return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
			}
		};

	} )();

	// Initialize.
	adpPopup.init();

	document.addEventListener('shopify:section:load', function () {
		adpPopup.init();
	});

	document.addEventListener('shopify:section:unload', function () {	
		$( 'body' ).removeClass( 'popup-scroll-hidden' );
	})
});
